// extracted by mini-css-extract-plugin
module.exports = {"list":"Menu-ltr_list__3Y29-","title":"Menu-ltr_title__3WX2Z","menuItemActive":"Menu-ltr_menuItemActive__3gmj9","activeCurve":"Menu-ltr_activeCurve__9oVD-"};